import css from 'styled-jsx/css';

const styles = css`
  .shop-the-project-container {
    position: absolute;
    width: 100%;
    bottom: 5px;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export default styles;
